module.exports = __webpack_public_path__ + "img/22200.901e9d6f.jpg";